import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { ItemCoverageType } from '../models/item.type.interface';
import { Job } from '../models/job.interface';
import { JobStatus } from '../models/job.status.enum';
import { RoleModule } from '../models/role.module.enum';
import { RolePermission } from '../models/role.permission.enum';
import { WorkOrderStatus } from '../models/work.order.status.enum';
import { ServiceLocator } from '../services/service.locator';
import { MessageDialog } from './message-dialog/message.dialog';

@Component({ template: '' })
export class AbstractBiditComponent {
  errors: string;

  isRequesting: boolean;
  isMobile: boolean;

  protected matDialog: MatDialog;

  constructor(deviceDetectorService: DeviceDetectorService) {
    // temporary fix... apple changed larger ipads to send back macintosh vs ipad.... when device detector catches up with this change
    // the or part of this statement can be removed
    this.isMobile = !deviceDetectorService.isDesktop() || (deviceDetectorService.isDesktop()  && this.isLargeTablet());
    this.matDialog = ServiceLocator.dialog;

    if (sessionStorage.getItem('full') != null) this.isMobile = false;
  }

  onError(response: string) {
    this.isRequesting = false;

    window.alert($localize`Sorry, something went wrong.  Please contact Bidit Support.` + 'r\n' + response);
    console.log(response);
  }

  //check larger ipad ---
  isLargeTablet() {
    /**
     * Had to introduce this check due to iPadOS, as Safari there now mimick's desktop*/
    var isIpad = navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
    var isTablet =  window.screen.availWidth <= 1366
    return isTablet;

      //if (!isIpad && navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
      //  return true;
      //}

      //return isIpad;
  }

  toggleFullSite() {
    sessionStorage.setItem('full', 'full');
    window.location.reload();
  }

  get workOrderStatuses(): WorkOrderStatus[] {
    let result: WorkOrderStatus[] = [];

    for (var n in WorkOrderStatus) {
      if (typeof WorkOrderStatus[n] === 'number') {
        result.push(parseInt(WorkOrderStatus[n]));
      }
    }

    return result;
  }

  showDialog(message: string,
    title: string | undefined = undefined,
    confirmText: string = 'OK',
    cancelText: string | undefined = undefined,
    maxWidth: string | undefined = undefined): Observable<boolean> {

    let confirmDialogRef = this.matDialog.open(MessageDialog, {
      data: {
        title: title,
        message: message,
        cancelText: cancelText,
        confirmText: confirmText
      },
      width: maxWidth,
      autoFocus: false
    });

    return confirmDialogRef.afterClosed();
  }

  getItemCoverageTypeName(coverageType: ItemCoverageType): string {
    switch (coverageType) {
      case ItemCoverageType.Blow:
        return $localize`Blow`;
      case ItemCoverageType.Inches:
        return $localize`Inches`;
      case ItemCoverageType.AeroBarrier:
        return $localize`AeroBarrier`;
      default:
        return $localize`Unknown`;
    }
  }

  getJobStatusName(job: Job): string {
    switch (job.jobStatus) {
      case JobStatus.NotScheduled:
        return $localize`Not Scheduled`;
      case JobStatus.Scheduled:
        return $localize`Scheduled`;
      case JobStatus.InProgress:
        return $localize`In Progress`;
      case JobStatus.Complete:
        return $localize`Complete`;
      case JobStatus.Canceled:
        return $localize`Canceled`
      default:
        return $localize`Unknown`;
    }
  }

  getWorkOrderStatusName(workOrderStatus: WorkOrderStatus): string {
    switch (workOrderStatus) {
      case WorkOrderStatus.Active:
        return $localize`Active`;
      case WorkOrderStatus.Canceled:
        return $localize`Canceled`;
      case WorkOrderStatus.Pending:
        return $localize`Pending`;
      case WorkOrderStatus.InProgress:
        return $localize`In Progress`;
      case WorkOrderStatus.Completed:
        return $localize`Completed`
      default:
        return $localize`Unknown`;
    }
  }

  getRoleModuleName(roleModule: RoleModule): string {
    switch (roleModule) {
      case RoleModule.Quotes:
        return $localize`Quotes`;
      case RoleModule.Jobs:
        return $localize`Jobs`;
      case RoleModule.Leads:
        return $localize`Leads`;
      case RoleModule.Customers:
        return $localize`Customers`;
      case RoleModule.Type:
        return $localize`Type`;
      case RoleModule.Reports:
        return $localize`Reports`;
      case RoleModule.Pricing:
        return $localize`Pricing`;
      default:
        return $localize`Unknown`;
    }
  }

  getRolePermissionName(rolePermission: RolePermission): string {
    switch (rolePermission) {
      case RolePermission.AddCustomer:
        return $localize`Ability to add a new customer.`;
      case RolePermission.EditCustomer:
        return $localize`Ability to edit an existing customer.`;
      case RolePermission.AddJob:
        return $localize`Ability to add a new job order (convert quote).`;
      case RolePermission.EditJob:
        return $localize`Ability to edit an existing job order.`;
      case RolePermission.AddLead:
        return $localize`Ability to add a new lead.`;
      case RolePermission.EditLead:
        return $localize`Ability to edit an existing lead.`;
      case RolePermission.AddQuote:
        return $localize`Ability to add a new quote.`;
      case RolePermission.EditQuote:
        return $localize`Ability to edit a quote.`;
      case RolePermission.SalesPerson:
        return $localize`Sales Person`;
      case RolePermission.FieldTechnician:
        return $localize`Field Technician`;
      case RolePermission.Salesperson_NonBIDIT:
        return $localize`Salesperson (Non-Bidit)`;
      case RolePermission.Admin:
        return $localize`Admin`;
      case RolePermission.ShowLineItemPricing:
        return $localize`Show Line Item Pricing`;
      case RolePermission.ShowCostBreakdown:
        return $localize`Show Cost Breakdown`;
      case RolePermission.ViewEditMargins:
        return $localize`View/Edit Margin % and Dollars`;
      case RolePermission.AddChangeOrder:
        return $localize`Ability to add a new change order`;
      case RolePermission.EditChangeOrder:
        return $localize`Ability to edit an existing change order`;
      case RolePermission.AddWorkOrder:
        return $localize`Ability to add a new work order`;
      case RolePermission.EditWorkOrder:
        return $localize`Ability to edit an existing work order`;
      case RolePermission.BidLog:
        return $localize`Bid Log`;
      case RolePermission.QuotesLeadsSource:
        return $localize`Quotes By Leads Source`;
      case RolePermission.LostQuoteAnalysis:
        return $localize`Lost Quote Analysis`;
      case RolePermission.CustQuoteContract:
        return $localize`Customer Quote and Contract`;
      case RolePermission.JobCost:
        return $localize`Job Cost`;
      case RolePermission.PayrollSummary:
        return $localize`Payroll Summary`;
      case RolePermission.EmailLog:
        return $localize`Email Log`;
      case RolePermission.SMSLog:
        return $localize`SMS Log`;
      case RolePermission.Inventory:
        return $localize`Inventory`;
      case RolePermission.QuoteAnalysis:
        return $localize`Quote Analysis`;
      default:
        return $localize`Unknown`;
    }
  }
}
